import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Languages } from "waapi/front-utils/hooks/useTranslation/types.js";
import { GetMeResponse200 } from "waapi/stargate-client/private/User/Me/GetMe/getMe.client.js";
import useRequest from "../../../../customHooks/useRequest.js";
import { buildUseStargateAccountQueryKey } from "../useStargateAccount/helpers/buildUseStargateAccountQueryKey.js";

export const useUpdateLanguage = () => {
    const updateLanguage = useRequest<"updateLanguage">("updateLanguage");
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (language: Languages) => updateLanguage({ body: { language } }),
        onSuccess: (result, language) => {
            if (result.hasFailed) return;
            queryClient.setQueryData<(GetMeResponse200 & { skipRestoreDataModal: boolean }) | null>(buildUseStargateAccountQueryKey(), (prev) =>
                prev ? { ...prev, language } : prev,
            );
        },
    });
};
